<template>
  <div>
    <b-loading :active.sync="loading_inicial" />
    <div v-if="lista_empresa_parcelamento">
      <div class="w-full flex justify-between items-center gap-2">
        <Lynx-Title text="Empresa" />

        <v-btn
          color="#031127"
          style="border-radius: 25px"
          dark
          small
          @click.native="listar_empresa_parcelamento()"
        >
          Atualizar</v-btn
        >
      </div>
      <div class="flex justify-end">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>Caso houver linhas, clique para interagir</span>
        </v-tooltip>
      </div>

      <div class="flex mb-4 gap-4">
        <label class="w-1/4">
          <Lynx-Label label="ID Empresas" class=" " />

          <input
            class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
            v-model="empresas_id"
            v-on:keyup.enter="listar_empresa_parcelamento"
          />
        </label>

        <label class="w-1/5">
          <Lynx-Label label="Carteiras" class=" " />

          <treeselect
            :multiple="true"
            :options="lista_carteiras"
            placeholder="Selecione as carteiras"
            v-model="filtros.carteiras"
          />
        </label>
           <label class="w-1/5">
          <Lynx-Label label="Seleciona um período" />
          <b-datepicker
            v-model="filtros.data"
            placeholder="Seleciona um período"
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-3, 3]"
            range
          >
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="filtros.data = null"
            />
          </b-datepicker>
        </label>
      </div>

      <b-table
        :columns="columns"
        :data="loading ? [] : lista_empresa_parcelamento"
        :loading="loading"
        backend-pagination
        paginated
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        :selected.sync="selected"
      >
        <template slot-scope="props" v-if="props.row.id != null">
          <b-table-column field="id">
            {{ props.row.id }}
          </b-table-column>
          <b-table-column field="razao_social">
            {{ props.row.razao_social }}
          </b-table-column>
          <b-table-column field="regime_tributario">
            {{ props.row.regime_tributario }}
          </b-table-column>

          <b-table-column field="carteiras_contabil">
            {{
              props.row.carteiras_contabil
                .map((carteira) => carteira.nome)
                .join(", ")
            }}
          </b-table-column>
          <b-table-column field="parcelamentos">
            <div
              v-for="parcelamento in props.row.parcelamentos"
              :key="parcelamento.id"
            >
              <v-chip v-if="parcelamento.parcela" color="primary" text-color="white">
                <span v-if="parcelamento.parcela.status == 2">Normal: </span>
                <span v-if="parcelamento.parcela.status == 3">Devedora: </span>
                <span class="ml-1">
                  {{ formatEnToBr(parcelamento.parcela.data_vencimento) }}
                </span>
              </v-chip>
            </div>
          </b-table-column>
        </template>
        <template v-slot:empty>
          <NotFoundData text="Nenhum parcelamento encontrado!" />
        </template>
      </b-table>
    </div>
    <div>
      <Parcelamento
        @listarEmpresaParcelamento="listar_empresa_parcelamento"
        :empresa="empresaSelecionada"
      />
    </div>
  </div>
</template>

<script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { monthNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import Parcelamento from "@/views/parcelas/Parcelamento.vue";

export default {
  components: { NotFoundData, Treeselect, Parcelamento },
  data() {
    return {
      monthNames,
      loading_inicial: false,
      modalParcelamento: false,
      loading: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      lista_campos: [],
      preciona: 0,
      editavel: 0,
      regimes_tributario: [],
      integracao: null,
      empresaSelecionada: null,
      columns: [
        {
          field: "id",
          label: "ID",
          sortable: true,
        },
        {
          field: "razao_social",
          label: "Razão Social",
          sortable: true,
        },
        {
          field: "regime_tributario",
          label: "Regime tributário",
          sortable: true,
        },
        {
          field: "carteiras_contabil",
          label: "Carteiras",
          sortable: true,
        },
        {
          field: "parcelamentos",
          label: "Parcelamentos",
        },
      ],
      filtros: {
        page: 1,
        perPage: 10,
        empresas_id: null,
        carteiras: [],
        data: null,
      },
      empresas_id: null,

      selected: null,
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    lista_empresa_parcelamento() {
      return this.$store.state.parcelamento.lista_empresa_parcelamento.data;
    },
    pagination() {
      return this.$store.state.parcelamento.lista_empresa_parcelamento
        .pagination;
    },
    mensagem_alert() {
      return this.$store.state.parcelamento.mensagem_alert;
    },
    lista_carteiras() {
      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      return data;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.listar_empresa_parcelamento();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_empresa_parcelamento();
    },
    selected() {
      this.goParcelamento(this.selected);
    },
  },
  mounted() {
    this.inicial();
  },
  methods: {
    hasRole,
    async inicial() {
      this.loading_inicial = true;
      await this.listar_empresa_parcelamento();
      this.listar_carteiras();
      this.loading_inicial = false;
    },
    goParcelamento(empresa) {
      this.empresaSelecionada = empresa;
      //   this.$router.push({ name: "parcelamento.index" });
    },
    listar_carteiras() {
      this.$store.dispatch("carteira/listar_carteiras");
    },
    async listar_empresa_parcelamento() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;
      await this.$store.dispatch(
        "parcelamento/listar_empresa_parcelamento",
        filtros
      );
      this.loading = false;
    },

    onPageChange(page) {
      this.current_page = page;
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
</style>
